import React from 'react';
import { Col, Space } from 'antd';

interface PaddingXProps {
  left?: boolean;
  right?: boolean;
  size?: React.ComponentProps<typeof Space>['size'];
  children: React.ReactNode;
}

const PaddingX = function ({
  left = false,
  right = false,
  size = undefined,
  children,
}: PaddingXProps) {
  return (
    <Space size={size}>
      {left && <Col />}
      {children}
      {right && <Col />}
    </Space>
  );
};

export default PaddingX;
